import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpContext} from '@angular/common/http';
import {map, Observable, retry} from 'rxjs';
import {Category} from '@core/models';
import {APP_CONFIG} from '@core/constants';
import {BYPASS_ERROR_HANDLING} from '@core/interceptors/api.interceptor';

@Injectable({
  providedIn: 'root'
})
export class ApiCatalog {

  private http = inject(HttpClient);
  private config = inject(APP_CONFIG);

  findAllCategories(): Observable<Category[]> {
    const url = `${this.config.baseUrl}/restaurant/categories`;
    return this.http.get<Array<Category>>(url, {

      context: new HttpContext().set(BYPASS_ERROR_HANDLING, true),

    }).pipe(
      retry(2),
      map(categories => {
        return categories.map(category => ({
          ...category,
          imageUrl: `${this.config.imgBase}${category.imageUrl}`,
          products: category.products?.map(product => ({
            ...product,
            categoryId: category.categoryId,
            imageUrl: `${this.config.imgBase}${product.imageUrl}`,
            quantity: 0,
            amount: product.price
          }))
        }));
      })
    );
  }


  updateCategory(categoryRaw: Category): Observable<Category> {
    const {imageUrl, ...category} = categoryRaw;
    const img = imageUrl?.replace('img/', '');
    const body = {folder: '', categories: [{...category, imageUrl: img}]};
    return this.http.put<Category>(`${this.config.baseUrl}/restaurant/category/${category.categoryId}`, body);
  }


  deleteItem(id: number, path: string): Observable<Category> {
    return this.http.delete<Category>(`${this.config.baseUrl}/restaurant/${path}/${id}`);
  }

  updateProductStatus(path: string, productId: number, active: boolean): Observable<any> {
    return this.http.put(`${this.config.baseUrl}/restaurant/${path}/${productId}/status`, {}, {
      params: {active: active.toString()}
    });
  }


  cancelOrder(orderId: string): Observable<any> {
    return this.http.delete(`${this.config.baseUrl}/restaurant/order/${orderId}/cancel`);
  }
}
